module.exports = __webpack_public_path__ + "static/media/diversity.baee902d.png";